'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _featuredContentBlock = require('@bibliocommons/featured-content-block');

var _featuredContentBlock2 = _interopRequireDefault(_featuredContentBlock);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

require('../styles/RecommendedFeaturedContent.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RecommendedFeaturedContent = function (_BcReactComponent) {
  _inherits(RecommendedFeaturedContent, _BcReactComponent);

  function RecommendedFeaturedContent() {
    _classCallCheck(this, RecommendedFeaturedContent);

    return _possibleConstructorReturn(this, (RecommendedFeaturedContent.__proto__ || Object.getPrototypeOf(RecommendedFeaturedContent)).apply(this, arguments));
  }

  _createClass(RecommendedFeaturedContent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          libraryShortName = _props.libraryShortName,
          content = _props.content;


      if (content.isEmpty()) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'cp-recommended-featured-content' },
        _react2.default.createElement(
          'h3',
          { className: 'content-recommended-by' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'related_resources',
            values: { library_short_name: libraryShortName } })
        ),
        _react2.default.createElement(
          'div',
          { className: 'content-container' },
          content.entrySeq().map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                contentType = _ref2[0],
                contentList = _ref2[1];

            return _react2.default.createElement(_featuredContentBlock2.default, { key: contentType, list: contentList, type: contentType, twoColumns: content.size === 1 });
          })
        )
      );
    }
  }]);

  return RecommendedFeaturedContent;
}(_baseBcReactComponent2.default);

RecommendedFeaturedContent.propTypes = {
  libraryShortName: _react.PropTypes.string.isRequired,
  content: _react.PropTypes.shape({
    BLOG_POST: _react.PropTypes.arrayOf(_bcPropTypes.featuredContentShape),
    RESOURCE: _react.PropTypes.arrayOf(_bcPropTypes.featuredContentShape),
    EVENT: _react.PropTypes.arrayOf(_bcPropTypes.featuredContentShape)
  })
};

exports.default = RecommendedFeaturedContent;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/recommended-featured-content/lib/components/RecommendedFeaturedContent.component.js
// module id = 1462
// module chunks = 1